import { render, staticRenderFns } from "./LeatherHero.vue?vue&type=template&id=7e245ac6&scoped=true"
var script = {}
import style0 from "./LeatherHero.vue?vue&type=style&index=0&id=7e245ac6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e245ac6",
  null
  
)

export default component.exports